export default function galleryViewMore() {
    const gallery = document.querySelector('.property-single__gallery');
    const viewMoreButton = gallery?.querySelector('.view-more');
    const hiddenImages = gallery?.querySelectorAll('.d-none');

    if (viewMoreButton && hiddenImages) {
        viewMoreButton.addEventListener('click', () => {
            hiddenImages.forEach(image => {
                image.classList.remove('d-none');
            });
            viewMoreButton.classList.add('d-none');
        });
    }
};
